<template>
  <!-- <Authority> -->
  <router-view v-slot="{ Component, route }">
    <component :is="Component" :key="route.meta.name" />
  </router-view>
  <div
    id="subapp-viewport-footer"
    style="position: fixed; bottom: 0; z-index: 999; right: 0; left: 0"
    v-if="showFooter"
  >
    <footer-menu />
  </div>
  <CS />
  <!-- </Authority> -->
</template>
<script setup>
import footerMenu from './components/footerMenu.vue'
import { useRouter } from 'vue-router'
import { ref } from 'vue'
// import Authority from './Authority.vue'
import CS from './views/cs/index.vue'
const showFooter = ref(false)

const router = useRouter()

router.beforeEach((to) => {
  const isShowFooter = [
    '/home',
    '/expense',
    '/mg/expense',
    '/common/mypage',
    '/mg/bi/subsidy/journeyList',
    '/mg/bi/subsidy/myOrder',
    '/common/mypage',
    '/common/management'
  ].includes(to.path)
  showFooter.value = isShowFooter
  // 允许侧滑
  if (window.$flutter?.support?.setWhetherSideSlidingIsAllowed) {
    window.$flutter.setWhetherSideSlidingIsAllowed(true)
  }
})
</script>
<style></style>
